var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiveUsoComercial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E1251B;}\n\t.st1{fill:none;stroke:#E1251B;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 3.1,
    className: "st0",
    width: 10.3,
    height: 42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.9,
    y: 3.1,
    className: "st0",
    width: 10.3,
    height: 42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 3.1,
    className: "st0",
    width: 10.3,
    height: 42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 3.1,
    className: "st0",
    width: 10.3,
    height: 42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29,3.1 40.6,3.1 25.8,23.3 14.5,23.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "90.9,3.1 104.7,3.1 73.7,45 73.7,26.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.2,24.8 14.5,24.8 29.4,45 40.6,45  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "144.2,0.6 137.8,8.1 149.8,23.3 161,23.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "149.4,24.8 161,24.8 144.2,46.6 137.3,39.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 3.1,
    className: "st0",
    width: 16.1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 19.3,
    className: "st0",
    width: 9.8,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 36,
    className: "st0",
    width: 16.1,
    height: 9.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.2,18.7c0.8,0.8,1.9,1.2,3.3,1.2c1.4,0,2.5-0.4,3.3-1.2c0.8-0.8,1.2-2,1.2-3.4V4.5h3.5v10.8 c0,1.6-0.3,3-1,4.2c-0.6,1.2-1.6,2.1-2.8,2.7c-1.2,0.6-2.6,0.9-4.2,0.9c-1.6,0-3.1-0.3-4.3-0.9c-1.2-0.6-2.1-1.5-2.8-2.7 c-0.6-1.2-1-2.6-1-4.2V4.5h3.5v10.8C179,16.8,179.4,17.9,180.2,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.3,7.9c-1-0.3-1.9-0.5-2.6-0.5c-0.8,0-1.5,0.2-2,0.5c-0.5,0.3-0.7,0.8-0.7,1.3c0,0.5,0.2,0.9,0.5,1.3 c0.3,0.3,0.8,0.6,1.3,0.8c0.5,0.2,1.2,0.5,2.1,0.7c1.2,0.4,2.3,0.7,3.1,1.1c0.8,0.4,1.5,0.9,2,1.6c0.6,0.7,0.8,1.7,0.8,2.8 c0,1.1-0.3,2.1-0.9,2.9c-0.6,0.8-1.4,1.5-2.5,1.9c-1.1,0.4-2.3,0.7-3.6,0.7c-1.4,0-2.8-0.3-4.2-0.8c-1.4-0.5-2.6-1.2-3.6-2.1l1.5-3 c0.9,0.9,2,1.5,3.1,2c1.2,0.5,2.2,0.7,3.2,0.7c1,0,1.7-0.2,2.3-0.6c0.6-0.4,0.8-0.9,0.8-1.5c0-0.5-0.2-1-0.5-1.3s-0.8-0.6-1.3-0.8 s-1.2-0.4-2.2-0.7c-1.2-0.4-2.3-0.7-3-1.1c-0.8-0.4-1.5-0.9-2-1.6c-0.6-0.7-0.8-1.6-0.8-2.8c0-1.1,0.3-2,0.9-2.8 c0.6-0.8,1.4-1.4,2.4-1.9c1-0.4,2.2-0.7,3.6-0.7c1.2,0,2.4,0.2,3.5,0.5c1.2,0.4,2.2,0.8,3.1,1.4l-1.4,3.1 C206.3,8.7,205.3,8.2,204.3,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.5,5.5c1.5,0.8,2.7,2,3.5,3.4c0.9,1.4,1.3,3,1.3,4.8s-0.4,3.3-1.3,4.8c-0.9,1.4-2,2.6-3.5,3.4 c-1.5,0.8-3.2,1.3-5,1.3c-1.8,0-3.5-0.4-5-1.3c-1.5-0.8-2.7-2-3.5-3.4c-0.9-1.4-1.3-3-1.3-4.8s0.4-3.3,1.3-4.8 c0.9-1.4,2-2.6,3.5-3.4c1.5-0.8,3.2-1.2,5-1.2C222.3,4.3,224,4.7,225.5,5.5z M217.4,8.3c-1,0.6-1.7,1.3-2.3,2.3s-0.8,2-0.8,3.2 c0,1.2,0.3,2.2,0.9,3.2c0.6,1,1.3,1.7,2.3,2.3s2,0.8,3.1,0.8c1.1,0,2.1-0.3,3.1-0.8s1.7-1.3,2.2-2.3c0.6-1,0.8-2,0.8-3.2 c0-1.2-0.3-2.2-0.8-3.2c-0.6-1-1.3-1.7-2.2-2.3s-2-0.8-3.1-0.8C219.4,7.4,218.4,7.7,217.4,8.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.8,8.1c-0.9-0.4-1.8-0.6-2.7-0.6c-1.1,0-2.2,0.3-3.1,0.8c-0.9,0.5-1.7,1.3-2.2,2.2c-0.5,1-0.8,2-0.8,3.1 c0,1.1,0.3,2.2,0.8,3.1s1.3,1.7,2.2,2.3c0.9,0.6,2,0.8,3.1,0.8c0.9,0,1.8-0.2,2.6-0.6s1.7-0.9,2.3-1.6l2.1,2.3 c-1,1-2.1,1.8-3.4,2.3c-1.3,0.6-2.6,0.9-3.9,0.9c-1.8,0-3.4-0.4-4.9-1.3c-1.5-0.8-2.6-2-3.5-3.4c-0.8-1.4-1.3-3-1.3-4.8 s0.4-3.3,1.3-4.8c0.9-1.4,2-2.6,3.5-3.4c1.5-0.8,3.1-1.2,4.9-1.2c1.3,0,2.6,0.3,3.9,0.8c1.3,0.5,2.3,1.3,3.2,2.2l-2,2.6 C252.5,9.1,251.7,8.5,250.8,8.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271,5.5c1.5,0.8,2.7,2,3.5,3.4c0.9,1.4,1.3,3,1.3,4.8s-0.4,3.3-1.3,4.8c-0.9,1.4-2,2.6-3.5,3.4 s-3.2,1.3-5,1.3s-3.5-0.4-5-1.3c-1.5-0.8-2.7-2-3.5-3.4c-0.9-1.4-1.3-3-1.3-4.8s0.4-3.3,1.3-4.8c0.9-1.4,2-2.6,3.5-3.4 c1.5-0.8,3.2-1.2,5-1.2S269.5,4.7,271,5.5z M263,8.3c-1,0.6-1.7,1.3-2.3,2.3c-0.6,1-0.8,2-0.8,3.2c0,1.2,0.3,2.2,0.9,3.2 s1.3,1.7,2.3,2.3c1,0.6,2,0.8,3.1,0.8c1.1,0,2.1-0.3,3.1-0.8c0.9-0.6,1.7-1.3,2.2-2.3s0.8-2,0.8-3.2c0-1.2-0.3-2.2-0.8-3.2 s-1.3-1.7-2.2-2.3c-0.9-0.6-2-0.8-3.1-0.8C265,7.4,263.9,7.7,263,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.9,4.5h4l6.1,11.8l6-11.8h4v18.4h-3.2V9.7L290.1,21h-2.3l-5.7-11.3v13.2h-3.2V4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.6,4.5h13.5v3.1h-9.9v4.5h8.9v3.1h-8.9v4.6h10.3v3.1h-13.8V4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.4,22.9l-3.2-5.4c-0.1,0-0.4,0-0.7,0h-4.1v5.4h-3.5V4.5h7.7c2.4,0,4.2,0.6,5.5,1.7 c1.3,1.1,1.9,2.7,1.9,4.7c0,1.4-0.3,2.7-0.9,3.7s-1.5,1.8-2.7,2.3l4,6.1H332.4z M324.5,14.4h4.1c1.3,0,2.3-0.3,3-0.9 c0.7-0.6,1-1.4,1-2.6c0-1.1-0.4-2-1-2.5c-0.7-0.6-1.7-0.8-3-0.8h-4.1V14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.9,8.1c-0.9-0.4-1.8-0.6-2.7-0.6c-1.1,0-2.2,0.3-3.1,0.8c-0.9,0.5-1.7,1.3-2.2,2.2c-0.5,1-0.8,2-0.8,3.1 c0,1.1,0.3,2.2,0.8,3.1c0.5,1,1.3,1.7,2.2,2.3c0.9,0.6,2,0.8,3.1,0.8c0.9,0,1.8-0.2,2.6-0.6c0.9-0.4,1.7-0.9,2.3-1.6l2.1,2.3 c-1,1-2.1,1.8-3.4,2.3c-1.3,0.6-2.6,0.9-3.9,0.9c-1.8,0-3.4-0.4-4.9-1.3c-1.5-0.8-2.6-2-3.5-3.4c-0.8-1.4-1.3-3-1.3-4.8 s0.4-3.3,1.3-4.8c0.9-1.4,2-2.6,3.5-3.4c1.5-0.8,3.1-1.2,4.9-1.2c1.3,0,2.6,0.3,3.9,0.8c1.3,0.5,2.3,1.3,3.2,2.2l-2,2.6 C352.6,9.1,351.8,8.5,350.9,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.2,4.5h3.5v18.4h-3.5V4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.8,22.9l-1.6-3.9h-9l-1.6,3.9h-3.6L372,4.5h3.6l8,18.4H379.8z M370.4,16h6.5l-3.2-7.7L370.4,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.8,4.5h3.5v15.2h7.9v3.2h-11.4V4.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.6,30.1l-6.7,12.4v6h-3.5v-5.9l-6.8-12.5h3.6l5,8.6l4.9-8.6H190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.3,30.1h13.5v3.1h-9.9v4.5h8.9v3.1h-8.9v4.6h10.3v3.1h-13.8V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.3,33.5c-1-0.3-1.9-0.5-2.6-0.5c-0.8,0-1.5,0.2-2,0.5c-0.5,0.3-0.7,0.8-0.7,1.3c0,0.5,0.2,0.9,0.5,1.3 c0.3,0.3,0.8,0.6,1.3,0.8c0.5,0.2,1.2,0.5,2.1,0.7c1.2,0.4,2.3,0.7,3.1,1.1s1.5,0.9,2,1.6c0.6,0.7,0.8,1.7,0.8,2.8 c0,1.1-0.3,2.1-0.9,2.9c-0.6,0.8-1.4,1.5-2.5,1.9c-1.1,0.4-2.3,0.7-3.6,0.7c-1.4,0-2.8-0.3-4.2-0.8c-1.4-0.5-2.6-1.2-3.6-2.1l1.5-3 c0.9,0.9,2,1.5,3.1,2c1.2,0.5,2.2,0.7,3.2,0.7c1,0,1.7-0.2,2.3-0.6c0.6-0.4,0.8-0.9,0.8-1.5c0-0.5-0.2-1-0.5-1.3 c-0.3-0.3-0.8-0.6-1.3-0.8c-0.5-0.2-1.2-0.4-2.2-0.7c-1.2-0.4-2.3-0.7-3-1.1s-1.5-0.9-2-1.6s-0.8-1.6-0.8-2.8c0-1.1,0.3-2,0.9-2.8 c0.6-0.8,1.4-1.4,2.4-1.9c1-0.4,2.2-0.7,3.6-0.7c1.2,0,2.4,0.2,3.5,0.5c1.2,0.4,2.2,0.8,3.1,1.4l-1.4,3.1 C227.2,34.3,226.3,33.8,225.3,33.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.1,33.7c-0.9-0.4-1.8-0.6-2.7-0.6c-1.1,0-2.2,0.3-3.1,0.8c-0.9,0.5-1.7,1.3-2.2,2.2c-0.5,1-0.8,2-0.8,3.1 c0,1.1,0.3,2.2,0.8,3.1c0.5,1,1.3,1.7,2.2,2.3c0.9,0.6,2,0.8,3.1,0.8c0.9,0,1.8-0.2,2.6-0.6c0.9-0.4,1.7-0.9,2.3-1.6l2.1,2.3 c-1,1-2.1,1.8-3.4,2.3c-1.3,0.6-2.6,0.9-3.9,0.9c-1.8,0-3.4-0.4-4.9-1.3c-1.5-0.8-2.6-2-3.5-3.4c-0.8-1.4-1.3-3-1.3-4.8 c0-1.7,0.4-3.3,1.3-4.8s2-2.6,3.5-3.4c1.5-0.8,3.1-1.2,4.9-1.2c1.3,0,2.6,0.3,3.9,0.8c1.3,0.5,2.3,1.3,3.2,2.2l-2,2.6 C245.8,34.7,245,34.1,244.1,33.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.3,31.1c1.5,0.8,2.7,2,3.5,3.4s1.3,3,1.3,4.8c0,1.8-0.4,3.3-1.3,4.8s-2,2.6-3.5,3.4 c-1.5,0.8-3.2,1.3-5,1.3c-1.8,0-3.5-0.4-5-1.3c-1.5-0.8-2.7-2-3.5-3.4c-0.9-1.4-1.3-3-1.3-4.8c0-1.7,0.4-3.3,1.3-4.8 c0.9-1.4,2-2.6,3.5-3.4c1.5-0.8,3.2-1.2,5-1.2C261.2,29.9,262.8,30.3,264.3,31.1z M256.3,33.9c-1,0.6-1.7,1.3-2.3,2.3 c-0.6,1-0.8,2-0.8,3.2s0.3,2.2,0.9,3.2c0.6,1,1.3,1.7,2.3,2.3c1,0.6,2,0.8,3.1,0.8c1.1,0,2.1-0.3,3.1-0.8c0.9-0.6,1.7-1.3,2.2-2.3 c0.6-1,0.8-2,0.8-3.2s-0.3-2.2-0.8-3.2s-1.3-1.7-2.2-2.3s-2-0.8-3.1-0.8C258.3,33,257.2,33.3,256.3,33.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.2,30.1h3.5v15.2h7.9v3.2h-11.4V30.1z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.2,48.5l-1.6-3.9h-9l-1.6,3.9h-3.6l8.1-18.4h3.6l8,18.4H300.2z M290.8,41.6h6.5l-3.2-7.7L290.8,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.7,48.5l-3.2-5.4c-0.1,0-0.4,0-0.7,0h-4.1v5.4h-3.5V30.1h7.7c2.4,0,4.2,0.6,5.5,1.7 c1.3,1.1,1.9,2.7,1.9,4.7c0,1.4-0.3,2.7-0.9,3.7c-0.6,1-1.5,1.8-2.7,2.3l4,6.1H317.7z M309.7,40h4.1c1.3,0,2.3-0.3,3-0.9 c0.7-0.6,1-1.4,1-2.6c0-1.1-0.3-2-1-2.5c-0.7-0.6-1.7-0.8-3-0.8h-4.1V40z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiveUsoComercial);
export default __webpack_public_path__ + "static/media/kive-uso-comercial.c508b1e0cf7e442a3acccc7dc9ae2e5c.svg";
export { ForwardRef as ReactComponent };